import Vue from 'vue'
import VueRouter from 'vue-router'
import { storeReset } from '@/store/storeReset'
import { isCompanyBlocked, redirectToPaywall } from '@/util/paywall'

import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
})


router.beforeEach((to, from, next) => {
  storeReset(to, from)

  if (to.matched.some((route) => route.meta.login)) {
    if (!localStorage['access_token']) {
      next('/login')
    } else {
      // Deliberately not awaited: navigation must never wait on hcheck. When the answer says the
      // subscription lapsed, the paywall (which lives in checklist-web) takes over then.
      isCompanyBlocked().then((blocked) => blocked && redirectToPaywall())
      next()
    }
  } else {
    next()
  }
})

export default router
